import { Navigate, useLocation } from "react-router-dom";
import UserData from "./UserData";
import Helpers from "./helpers";

/**
 * Hard login gate: when logged in and pending RequiredForLogin agreements exist,
 * force signing before other authenticated routes. Mirrors MustChangePasswordGate
 * placement in App (runs after password gate clears).
 */
export default function RequiredAgreementsGate({ children }) {
  const location = useLocation();
  const userData = UserData.UserData() || {};
  const path = (location.pathname || "/").toLowerCase();

  if (Helpers.isLoginAgreementEscapePath(path)) {
    return children;
  }

  const pending = Helpers.pendingLoginAgreements(userData);
  if (pending.length === 0) {
    return children;
  }

  const id = pending[0].AgreementID || pending[0].agreementID;
  if (!id) {
    return children;
  }

  const target = `/agreementSignature/${id}`;
  if (path === target.toLowerCase() || path.startsWith(`${target.toLowerCase()}/`)) {
    return children;
  }

  return (
    <Navigate
      to={target}
      replace
      state={{ returnTo: location.pathname, loginGate: true }}
    />
  );
}
